import { Card, CircularProgress, Divider, Grid, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import React, { useState } from "react";
import { Button, FileField, FileInput, SelectInput, TextInput, Toolbar, required, useNotify } from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { RequestExcusableShippingType } from "../../../src/Enums/RequestExcusableShippingType";
import { CustomDatetime } from "../../Components/CustomDatetime";
import { SectionTitle } from "../../Components/SectionTitle";
import { Separator } from "../../Components/Separator";
import { RequestExcusableStatus } from "../../Enums/RequestExcusableStatus";
import { RequestExcusableType } from "../../Enums/RequestExcusableType";
import { useAppDataProvider } from "../../dataprovider";
import { ExcusableCreateModel } from "../RequestOrder/Models/ExcusableCreateModel";
import { excusableTypes, shippingTypes } from "./Constant/Source";
import { DownloadButton, useAuth } from "@airborne/react-admin";
import { FileAcceptWhiteList } from "../../Constants/Constant";

const useStyles = makeStyles(theme => ({
  toolbar: {
    display: "flex",
    justifyContent: "end",
  },
  gridItem: {
    margin: "0px 10px",
  },
}));

export const Excusable = (props: any) => {
  const classes = useStyles(props);
  const history = useHistory();
  const provider = useAppDataProvider();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const [requestId, setRequestId] = useState(0);
  const [requestOrderType, setRequestOrderType] = useState(0);
  const [fileList, setFileList] = useState([] as any);
  const [isValidExcusable, setIsValidExcusable] = useState(false);
  const { user } = useAuth();

  const handleSubmit = e => {
    let excusableCreateModel: ExcusableCreateModel = new ExcusableCreateModel();
    excusableCreateModel.AgreementRef = e?.agreementRef;
    excusableCreateModel.Description = e?.description;
    excusableCreateModel.RequestOrderId = requestId;
    excusableCreateModel.ShippingType = e?.shippingType;
    excusableCreateModel.Type = e?.shippingType === 1 ? RequestExcusableType.Normal : e?.excusableType;
    excusableCreateModel.Status =
      excusableCreateModel.Type != RequestExcusableType.Normal
        ? RequestExcusableStatus.Accepted
        : RequestExcusableStatus.Opened;
    excusableCreateModel.RequestOrderType = requestOrderType;
    excusableCreateModel.Files = fileList;
    setLoading(true);
    provider
      .postRequestExcusable(excusableCreateModel)
      .then(result => {
        let resultData = result.data;
        history.push("/requestorderexcusables/" + resultData.id + "?requestType=" + requestOrderType);
        notify(`Record created`, "success", false, true);
      })
      .catch(result => {
        notify(`${result?.response?.data?.message ?? result}`, "error", false, true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleBlur = form => e => {
    const refNo = form?.getState?.()?.values?.refNo;
    const shippingType = form?.getState?.()?.values?.shippingType;
    if (refNo != null && refNo != undefined && refNo != "") {
      provider.GetOrderDetailByRefNo(`refNo=${refNo}&shippingType=${shippingType ?? -1}`).then(result => {
        const data = result?.data?.data;
        if (data.excusableId > 0) {
          history.push("/requestorderexcusables/" + data.excusableId + `?requestType=${data.requestOrderType}`);
        }
        setIsValidExcusable(!data.pn);

        setRequestId(data?.requestId ?? 0);
        setRequestOrderType(data?.requestOrderType ?? 0);
        form.change("customerCode", data.customerCode);
        form.change("customerRequestComponent", data.customerRequestComponent);
        form.change("componentDescription", data.componentDescription);
        form.change("melCategory", data.melCategory);
        form.change("requestedDeliveryDate", data.requestedDeliveryDate);

        form.change("estimatedDeliveryDate", data.estimatedDeliveryDate);
        form.change("flightDate", data.flightDate);
        form.change("pn", data.pn);
        form.change("sn", data.sn);
        form.change("excusableId", data.excusableId);
        form.change("excusableStatus", data.excusableStatus);
        form.change("excusableType", data.excusableType);
      });
    }
  };

  const handleFileChange = async fileObj => {
    let file: File = fileObj[0];
    const {
      data: { objectKey },
    } = await provider.uploadFileMinio(file);
    var tempFiles = fileList;
    tempFiles.push({ id: 0, name: file.name, objectKey: objectKey });
    setFileList([...tempFiles]);
  };

  return (
    <Form
      onSubmit={handleSubmit}
      render={({ handleSubmit, form, values }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Card>
              <Grid container spacing={0} style={{ padding: 25 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <SectionTitle label="Order Info" />
                  <Divider style={{ padding: 0 }} />
                  <Separator />
                </Grid>
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  <TextInput
                    source="refNo"
                    label="Ref No"
                    fullWidth
                    validate={required()}
                    variant="outlined"
                    onBlur={handleBlur(form)}
                  />
                  <TextInput source="customerCode" label="Customer" fullWidth disabled variant="outlined" />
                  <TextInput
                    source="customerRequestComponent"
                    label="Requested Part Number"
                    fullWidth
                    disabled
                    variant="outlined"
                  />
                  <TextInput
                    source="componentDescription"
                    label="Component Description"
                    fullWidth
                    disabled
                    variant="outlined"
                  />
                  <TextInput source="melCategory" label="Category" fullWidth disabled variant="outlined" />
                  <CustomDatetime
                    source="requestedDeliveryDate"
                    label="Requested Delivery Date"
                    fullWidth
                    showTime
                    disabled
                    variant="outlined"
                  />
                  {values.shippingType == RequestExcusableShippingType.Serviceable && (
                    <SelectInput
                      source="excusableType"
                      choices={excusableTypes}
                      optionText="label"
                      optionValue="id"
                      fullWidth
                      disabled={values.excusableId > 0}
                      variant="outlined"
                      validate={required()}
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={1} />
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  <SelectInput
                    source="shippingType"
                    choices={shippingTypes}
                    optionText="label"
                    optionValue="id"
                    initialValue={
                      user?.isCustomer
                        ? RequestExcusableShippingType.Unserviceable
                        : RequestExcusableShippingType.Serviceable
                    }
                    fullWidth
                    disabled={true}
                    variant="outlined"
                    validate={required()}
                  />
                  <CustomDatetime
                    source="flightDate"
                    label="Forward Date to Carrier"
                    fullWidth
                    showTime
                    disabled
                    variant="outlined"
                  />
                  <CustomDatetime
                    source="estimatedDeliveryDate"
                    label="Estimated Delivery Date"
                    fullWidth
                    showTime
                    disabled
                    variant="outlined"
                  />
                  <TextInput source="pn" label="PN" fullWidth disabled variant="outlined" />
                  <TextInput source="sn" label="SN" fullWidth disabled variant="outlined" />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Separator />
                  <Separator />
                  <SectionTitle label="Excusable Detail" />
                  <Divider />
                  <Separator />
                </Grid>
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  <TextInput
                    source="agreementRef"
                    label="Agreement Article Reference"
                    fullWidth
                    validate={required()}
                    variant="outlined"
                  />
                  <FileInput
                    style={{ disabled: false }}
                    source="src"
                    label={props.label}
                    multiple={props.multiple}
                    options={{ onDrop: fileObj => { handleFileChange(fileObj); } }}
                    validate={required()}
                    RaFileInput={false}
                    accept={FileAcceptWhiteList}
                  >
                    <FileField source="src" title="title" />
                  </FileInput>

                  {fileList.map(file => {
                    return (
                      <DownloadButton target={`download/${file.objectKey}`} buttonText={file.name} variant="text" />
                    );
                  })}
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={1} />
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  <TextInput
                    source="description"
                    label="Description"
                    fullWidth
                    multiline
                    minRows={4}
                    validate={required()}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4}></Grid>
              </Grid>

              <Toolbar {...props} placeholder="" className={classes.toolbar}>
                <Button
                  label={loading ? "Creating!" : "Create Excusable Delay"}
                  disabled={isValidExcusable}
                  size="medium"
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                </Button>
              </Toolbar>
            </Card>
          </form>
        );
      }}
    ></Form>
  );
};
export default Excusable;
